import React, { useEffect, useMemo } from 'react';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';
import { useDispatch, useSelector } from 'react-redux';
import { setActionReasons } from '../../../../../../actions/tools/OrdersSearchActions';
import { getActionReasons } from '../../../../../../extractFromState';
import { normalizeSnakeCase } from '../../../../../../util';
import { SecondaryReasonInput, SelectHolder, selectInputsReactSelectStyles } from './SelectInputs.styles';

const SelectInputs = ({ placeholder = '', options, fields, isCustomOption = false }) => {
  const dispatch = useDispatch();

  const actionReasons = useSelector(getActionReasons);

  const handleUpdateFields = (value, field) => {
    const updatedActionReasons = Object.assign({}, actionReasons || {}, { [field]: value });
    dispatch(setActionReasons(updatedActionReasons));
  };

  useEffect(() => {
    dispatch(setActionReasons(null));
  }, [dispatch]);

  const selectOptions = useMemo(() => {
    if (options && Array.isArray(options)) {
      return options.map((option) => ({
        value: option,
        label: !isCustomOption ? normalizeSnakeCase(option) : option,
      }));
    }
  }, [options, isCustomOption]);

  return (
    <>
      <SelectHolder>
        <BaseSelect
          defaultSelect={false}
          isClearable
          placeholder={placeholder}
          options={selectOptions}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : null;
            handleUpdateFields(value, fields.primaryReason);
          }}
          styles={selectInputsReactSelectStyles}
        />
      </SelectHolder>
      {fields.secondaryReason && (
        <SecondaryReasonInput
          placeholder="Add a comment (optional)"
          onChange={(e) => handleUpdateFields(e.target.value, fields.secondaryReason)}
          value={actionReasons ? actionReasons[fields.secondaryReason] : ''}
        />
      )}
    </>
  );
};

export default SelectInputs;
